import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initBlockDevelopersHub(parent) {
  if (!parent) return;

  const links = parent.querySelectorAll('.block-developers-hub__link');

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: parent,
      start: 'top 75%',
      toggleActions: 'play none none none',
      once: true,
      // markers: true,
    },
  });

  tl.fromTo(
    links,
    { autoAlpha: 0, x: -30 },
    {
      autoAlpha: 1,
      x: 0,
      duration: 0.8,
      ease: 'power2.out',
      stagger: 0.12,
    },
  );
}

export function initAllBlockDevelopersHub() {
  const blocks = document.querySelectorAll('.js-block-developers-hub');
  blocks.forEach((block) => initBlockDevelopersHub(block));
}
